import React, { useState } from 'react';
import Logo from '../Logo/Logo';
import { Col, Container, FormGroup, Row, } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { Shadow, WerfenColorMid, White } from '../../Constants/ColorChart';
import Loader from "../Loader/Loader";
import { Wrapper } from '../../CommonForm/StyledFormComponents';
import FieldGroup from './../../CommonForm/FieldGroup';
import CustomCheckbox from "../../CommonForm/CustomCheckbox";

/*
 *  @Description:   Component that shows an auto-enrollment form
 */

const checkBoxes = [
    { name: "autoimmunity", label: "Autoimmunity" },
    { name: "bloodGas", label: "Blood Gas" },
    { name: "clinicalChemistry", label: "Clinical Chemistry" },
    { name: "hemostasis", label: "Hemostasis" },
    { name: "patientBloodManagement", label: "Patient Blood Management" },
    { name: "wholeBloodHemostasis", label: "Whole Blood Hemostasis" }
];

const CustomSelect = React.forwardRef( ( { name, label, error, register, id, refObject, message }, ref ) => (
    <FormGroup controlId={ id }>
        <label className={ "control-label" }>{ label }</label>
        <select className={ "form-select" } name={ name } ref={ ref }>
            <option>Please choose one...</option>
            <option value="1">Service Specialist/Service Engineer</option>
            <option value="2">Service Manager</option>
            <option value="3">Application Specialist/ Product Specialist
                Specialist/ Product Specialist
            </option>
            <option value="4">Marketing Specialist</option>
            <option value="5">Marketing Manager</option>
            <option value="6">General Manager</option>
            <option value="7">Product Manager</option>
            <option value="8">CEO</option>
            <option value="9">Business Manager</option>
            <option value="10">Laboratory Technician</option>
            <option value="11">Medical Staff</option>
            <option value="12">ClinicalEngineer</option>
            <option value="13">Other</option>
        </select>
        { error && <span className={ "helpBlock" }>{ message }</span> }
    </FormGroup>
) );

// noinspection DuplicatedCode
const sendDataToVerify = ( params ) => {
    return new Promise( ( resolve, reject ) => {
        fetch( params.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify( params.dataToSend ),
        } ).then(
            ( res ) => {
                params.methodLoading( false );
                if ( res.status === 200 ) {
                    params.methodSuccess( true );
                    if ( params.methodCallback !== undefined ) {
                        params.methodCallback();
                        resolve( true )
                    }
                    //return true;
                } else {
                    params.methodFailure( true );
                    resolve( false )
                    //return false;
                }
            }
        ).catch( ( err ) => {
            params.methodLoading( false );
            params.methodFailure( true );
            // console.error("Error on fetch: ", err);
            reject( err );
        } );
    } )
}


const AutoEnrollment = () => {
    const { register, handleSubmit, getValues, errors, watch } = useForm();
    const [ submitFlag, setSubmitFlag ] = useState( false );
    const [ isLoading, setLoading ] = useState( false );
    const [ dataVerified, setDataVerified ] = useState( false );
    const [ dataError, setDataError ] = useState( false );
    const onSubmit = data => {
        // const emailUrl = 'https://httpstat.us/200?sleep=500'
        const emailUrl = process.env.REACT_APP_BACKEND_MACHINE + '/eemeai/register/distributors';
        const emailToSend = data;
        setLoading( true );
        const params = {
            dataToSend: emailToSend,
            url: emailUrl,
            methodLoading: setLoading,
            methodSuccess: setDataVerified,
            methodFailure: setDataError,
            methodCallback: redirect
        }
        // noinspection JSUnusedLocalSymbols
        sendDataToVerify( params )
            .then( ( response ) => {
                setDataVerified( response );
                setDataError( !response );
            } )
            .catch( ( error ) => {
                // console.error( "Error: ", error )
            } )
        //setDataError(!sendDataToVerify(params));
    }
    const redirect = () => {
        setTimeout( () => window.location.assign( '/' ), 2000 );
    }
    const checkAtLeastOne = () => {
        let arr = checkBoxes.filter(
            ( el, index ) => !!watch( `elements[${ index }]` ) === true
        );
        return arr.length > 0;
    };
    const otherValueSelected = watch( "formControlJobTitle" ) === "13";
    return <Wrapper className={ "AutoEnrollment" }>
        <div className={ "Stage" }>
            <div className={ "Logo" }>
                <Logo/>
            </div>
            { isLoading &&
            <Loader message="Loading content" primaryColor={ WerfenColorMid }
                    secondaryColor={ Shadow } fontColor={ White }/> }
            { !isLoading && dataError && !dataVerified && <div className="confirmation-message">
                <p>Some error has occurred.</p>
                <p>Please contact your administrator.</p>
            </div> }
            { !isLoading && dataVerified && !dataError && <div className="confirmation-message">
                <p>Thank you for subscribing.</p>
                <p>Your registration process has been completed successfully.</p>
            </div> }
            { !isLoading && !dataVerified &&
            <form onSubmit={ handleSubmit( onSubmit ) } className={ "Form Form-autoenrollment" }>
                <Container>
                    <Row>
                        <Col xs={ 12 } md={ 4 }>
                            <FieldGroup
                                id="formControlsUsername"
                                type="text"
                                label="Username*"
                                name="formControlsUsername"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your user name"
                                error={ errors["formControlsUsername"] }
                                help={ "User name is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsFirstName"
                                type="text"
                                label="First Name*"
                                name="formControlsFirstName"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your first name"
                                error={ errors["formControlsFirstName"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsLastName"
                                type="text"
                                label="Last Name*"
                                name="formControlsLastName"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your last name"
                                error={ errors["formControlsLastName"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <CustomSelect
                                id="formControlJobTitle"
                                name="formControlJobTitle"
                                label="Job title*"
                                error={ errors["formControlJobTitle"] }
                                message={ "Please select a job title" }
                                ref={ register( {
                                    required: "Please select a job title",
                                    validate: () => {
                                        const { formControlJobTitle } = getValues()
                                        return formControlJobTitle !== "Please choose one..." || "Please select a job title";
                                    }
                                } ) }
                            />
                            { otherValueSelected && <FieldGroup
                                id="otherJobTitle"
                                type="text"
                                label="Other job title*"
                                name="otherJobTitle"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your job title"
                                error={ errors["otherJobTitle"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            }
                        </Col>
                        <Col xs={ 12 } md={ 4 }>
                            <FieldGroup
                                id="formControlsEmail"
                                type="email"
                                label="Email address*"
                                name="formControlsEmail"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your email address"
                                error={ errors["formControlsEmail"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsConfirmEmail"
                                type="email"
                                label="Confirm email*"
                                name="formControlsConfirmEmail"
                                className={ "" }
                                placeholder="Confirm your email address"
                                error={ errors["formControlsConfirmEmail"] }
                                help={ "This field is required" }
                                message={ "Emails should match!" }
                                refObject={ {
                                    required: 'Please confirm email!',
                                    validate: ( value ) => {
                                        const { formControlsEmail } = getValues();
                                        return formControlsEmail === value || 'Emails should match!';
                                    },
                                } }
                                register={ register }
                            />
                            <FieldGroup
                                id="formControlsPassword"
                                label="Password*"
                                type="password"
                                name="formControlsPassword"
                                className={ "" }
                                refObject={ {
                                    required: "This field is required",
                                    pattern: {
                                        value: /((?=.*?[A-Z]+)(?=.*?[a-z]+)(?=.*?[0-9]+)(?=.*?\W)).{8,}/,
                                        message: "A password needs to have 1 uppercase, 1 lowercase, 1 digit, 1 symbol and be at least 8 characters long."
                                    }
                                } }
                                register={ register }
                                placeholder="Enter your desired password"
                                error={ errors["formControlsPassword"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsRepeatPassword"
                                label="Repeat password*"
                                type="password"
                                name="formControlsRepeatPassword"
                                className={ "" }
                                register={ register }
                                placeholder="Repeat your password"
                                error={ errors["formControlsRepeatPassword"] }
                                help={ "This field is required" }
                                message={ 'Passwords should match!' }
                                refObject={ {
                                    required: 'Please confirm password!',
                                    validate: ( value ) => {
                                        const { formControlsPassword } = getValues();
                                        return formControlsPassword === value || 'Passwords should match!';
                                    },
                                } }
                            />
                        </Col>
                        <Col xs={ 12 } md={ 4 }>
                            <FieldGroup
                                id="formControlsCompany"
                                type="text"
                                label="Company*"
                                name="formControlsCompany"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your company name"
                                error={ errors["formControlsPassword"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsPhone"
                                type="text"
                                label="Phone*"
                                name="formControlsPhone"
                                className={ "" }
                                register={ register }
                                placeholder="Enter phone"
                                error={ errors["formControlsPhone"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsPostalCode"
                                type="text"
                                label="Postal code*"
                                name="formControlsPostalCode"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your postal code"
                                error={ errors["formControlsPostalCode"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                            <FieldGroup
                                id="formControlsCountry"
                                type="text"
                                label="Country*"
                                name="formControlsCountry"
                                className={ "" }
                                register={ register }
                                placeholder="Enter your country"
                                error={ errors["formControlsCountry"] }
                                help={ "This field is required" }
                                required={ true }
                            />
                        </Col>
                        <Col xs={ 12 }>
                            <div className="businessLinesWrapper">
                                <label>Business lines*</label>
                                { submitFlag && !checkAtLeastOne() &&
                                <span className={ "helpBlock" }>Check at least one</span> }
                            </div>
                        </Col>
                        <Col xs={ 12 }>
                            <FormGroup>
                                { checkBoxes.map( ( item, index ) => {
                                    return (
                                        <CustomCheckbox
                                            key={ `element.${ item.label }` }
                                            label={ item.label }
                                            id={ index }
                                            name={ `elements[${ index }]` }
                                            register={ register( {
                                                validate: () => {
                                                    return checkAtLeastOne();
                                                }
                                            } ) }
                                        />
                                    );
                                } ) }
                            </FormGroup>
                        </Col>
                        <Col xs={ 12 }>
                            <input className="buttonSubmit" value="submit" onClick={ () => setSubmitFlag( true ) }
                                   type="submit"/>
                        </Col>
                    </Row>
                </Container>
            </form> }
        </div>
    </Wrapper>
};

export default AutoEnrollment;

